import styles from "./MenuOverlay.module.scss";
import MenuOverlayProps from "./MenuOverlayProps";

import { CLOSE_ALL_OVERLAYS } from "layout/redux/overlay.actions";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import Anchor from "components/Anchor/Anchor";
import Button from "components/Button/Button";
import IconViewer from "components/IconViewer/IconViewer";
import React, { FunctionComponent, useCallback, useEffect, useState } from "react";
import useWindowDimensions from "hooks/useWindowDimensions";
import { Portal } from "react-portal";

const MenuOverlay: FunctionComponent<MenuOverlayProps> = (props) => {
    const { width } = useWindowDimensions();
    const dispatch = useDispatch();

    const headerButtonContentType = props.header?.headerButtons?.[0] && props.header.headerButtons.length > 0 ? props.header.headerButtons[0].content._contentType : undefined;
    const [currentSubmenu, setCurrentSubmenu] = useState<any>(undefined);

    const onEscKeyInput = useCallback((event) => {
        if (event.keyCode === 27) {
            dispatch({
                type: CLOSE_ALL_OVERLAYS
            });
        }
    }, []);

    const onCloseButtonClick = useCallback((event) => {
        dispatch({
            type: CLOSE_ALL_OVERLAYS
        });
    }, []);

    useEffect(() => {
        document.addEventListener("keydown", onEscKeyInput, false);

        return () => {
            document.removeEventListener("keydown", onEscKeyInput, false);
        };
    }, []);

    return (
        <Portal node={document && document.getElementById("wrapper")}>
            {/* Lock the scrollbar for the rest of the page on mobile, while drawer is open */}
            {/* TODO: Remember the scroll position and restore it when toggling locked state */}
            {width <= 570 ? <Helmet bodyAttributes={{ class: "is-locked" }} /> : null}

            <nav className={styles.wrapper} style={props.headerStyles}>
                <div className={styles.inner}>
                    <div className={styles.header}>
                        <button className={styles.menu_close_button} onClick={(event) => onCloseButtonClick(event)}>
                            <span></span>
                            <span></span>
                        </button>
                    </div>

                    {typeof (currentSubmenu) === "undefined" && props.menu ? (
                        <div className={styles.links}>
                            {props.menu?.map((level1Item: any, index: number) => {
                                return (
                                    <span key={index} className={styles.item}>
                                        <Anchor className={styles.link} to={level1Item.content.link}>
                                            <span className={styles.link_label}>{level1Item.content.label}</span>
                                        </Anchor>

                                        {level1Item.content.subMenu && level1Item.content.subMenu.length > 0 ? (
                                            <button className={styles.link_button} onClick={() => setCurrentSubmenu(level1Item)}>
                                                <IconViewer className={styles.link_button_icon} name="plus" />
                                            </button>
                                        ) : null}
                                    </span>
                                );
                            })}
                        </div>
                    ) : null}

                    {typeof (currentSubmenu) !== "undefined" && currentSubmenu.content.subMenu && currentSubmenu.content.subMenu.length > 0 ? (
                        <button className={styles.back_button} onClick={() => setCurrentSubmenu(undefined)}>
                            <IconViewer className={styles.back_icon} name="chevron-circle-left" />
                            {currentSubmenu.content.label}
                        </button>
                    ) : null}

                    {typeof (currentSubmenu) !== "undefined" && currentSubmenu.content.subMenu && currentSubmenu.content.subMenu.length > 0 ? (
                        <div className={styles.links}>
                            {currentSubmenu.content.subMenu?.map((level2Item: any, index: number) => {
                                return (
                                    <span key={index} className={styles.item}>
                                        <Anchor className={styles.link} to={level2Item.content.link}>
                                            <span className={styles.link_label}>{level2Item.content.label}</span>
                                        </Anchor>
                                    </span>
                                );
                            })}
                        </div>
                    ) : null}
                </div>
            </nav>
        </Portal>
    );
};

export default MenuOverlay;